// extracted by mini-css-extract-plugin
export default {"wrapper":"Upload_wrapper__7C1+R","label":"Upload_label__8jsjl","isValue":"Upload_isValue__OD3qO","name":"Upload_name__jGx3i","value":"Upload_value__3DoNM"};